export function shouldShowTicket(): boolean {
    const cookieValue = +localStorage.getItem('ticketsStory') || 0;

    if (!cookieValue) {
        return true;
    }

    const sixHoursAgo = Date.now() - 6 * 60 * 60 * 1000;

    return (cookieValue < sixHoursAgo);
}

export function saveTicketState(): void {
    localStorage.setItem('ticketsStory', Date.now().toString());
}